import { Text as Paragraph, Title } from '../../Typography';
import { NextLink } from '../../NextLink';

interface IngredientType {
  summary: string;
  amount?: string;
  productLink?: string | null;
}
interface IngredientProps {
  ingredient: IngredientType;
  trackingEvent?: (data: IngredientType) => void;
}

export const Ingredient = ({ ingredient, trackingEvent }: IngredientProps) => {
  return (
    <div
      key={ingredient.summary}
      itemProp="ingredients"
      className="ingredientText flex flex-col mmd:flex-row justify-start mb-3 print:break-inside-avoid print:relative"
    >
      <Title
        className="pr-2 whitespace-nowrap mmd:text-right min-w-[25%] mdd:w-2/6 lg:w-26pc llg:w-2/12 md:text-sm llg:text-lg print:break-inside-avoid print:relative"
        tag="div"
        type="xxxs"
        isContainer
      >
        {ingredient.amount}
      </Title>
      <Paragraph
        className="flex items-end mdd:w-4/6 lg:w-10/12 print:break-inside-avoid print:relative break-all"
        tag="div"
        type="md"
      >
        {ingredient.productLink ? (
          <NextLink
            href={ingredient.productLink || ''}
            target="_blank"
            rel={'noopener noreferrer'}
            className="print:break-inside-avoid print:relative underline"
            onClick={() => trackingEvent && trackingEvent(ingredient)}
          >
            {' '}
            {ingredient.summary}
          </NextLink>
        ) : (
          <>
            <> </>
            {ingredient.summary}
          </>
        )}
      </Paragraph>
    </div>
  );
};
